module.exports = __webpack_public_path__ + "img/waiting.9a40f046.svg";